<template>
  <div class="d-flex flex-column flex-grow-1 rounded mr-md-3">
    <BaseToolBar title="Suivis d'affaire" subtitle="Liste des suivis / visites réalisées">      
      <BaseButton
      class="btn btn-primary ml-3"
      v-tooltip="'Ajouter un suivi'"
      @click="createSuivi(id)"
      :loading="loading"
      icon="plus"
      text="Ajouter"
    ></BaseButton>
    </BaseToolBar>
    <div class="d-flex flex-column flex-md-row w-100">
      <div class="flex-grow-1 d-flex flex-column flex-md-row flex-wrap mb-3" v-if="suivis">
        <div v-for="suivi in suivis" :key="suivi.id" class="w-100">
          <SuiviItem :suivi="suivi" :lists="lists"></SuiviItem>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapMultiRowFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import BaseToolBar from "@/components/bases/ToolBar.vue";
import SuiviItem from "@/components/affaires/SuiviItem.vue";
import BaseButton from "@/components/bases/Button.vue";

export default {
  components: { BaseToolBar, SuiviItem, BaseButton },
  data() {
    return {
      lists: {},
      feedback: {},
      loading:false
    };
  },
  props: {},
  computed: {
    ...mapFields("affaires", ["affaire.id"]),
    ...mapMultiRowFields("affaires", ["suivis"])
  },
  methods: {
    ...mapActions({
      _createSuivi: "affaires/createSuivi"
    }),
    createSuivi: function(d) {
      this.feedback = {};
      this.loading = true;
      this._createSuivi(d)
      .catch(error => this.errHandler(error))
      .finally(() => (this.loading = false));
    },
    errHandler: function(error) {
      if (error.response.status === 422) {
        this.feedback = error.response.data.error;
        return;
      }
    }
  },
  mounted() {}
};
</script>
